import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

const CounterInput = (props) => {
  const handleIncrement = () => {
    if (props.disabled) {
      return;
    }

    props.setCount((prev) => (props.maxValue ? (prev < props.maxValue ? prev + 1 : props.maxValue) : prev + 1));
  };
  const handleDecrement = () => {
    if (props.disabled) {
      return;
    }

    props.setCount((prev) => (prev > props.minValue ? prev - 1 : props.minValue));
  };

  const areMinAndMaxSame = () => {
    return props.minValue === props.maxValue;
  };

  return (
    <Box data-testid={"input-actions"} sx={{ textAlign: "center" }}>
      <Grid container direction="column" alignItems={"center"}>
        <Grid>
          <Typography fontSize={"16px"} sx={{ fontWeight: "bold", color: "primary.swaBlue" }}>
            {props.title}
          </Typography>
        </Grid>
        <Grid>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Grid container alignItems={"center"} sx={{ color: "secondary.swaGray" }}>
              <Grid item>
                <Typography sx={{ fontWeight: "bold", fontSize: "36px", color: "black" }}>{props.count}</Typography>
              </Grid>
              {!areMinAndMaxSame() && (
                <Grid item sx={{ marginTop: "5px" }}>
                  <Grid>
                    <ArrowDropUpIcon
                      fontSize="large"
                      data-testid={"increment-btn"}
                      sx={{ cursor: props.disabled ? "auto" : "pointer" }}
                      onClick={handleIncrement}
                    />
                  </Grid>
                  <Grid>
                    <ArrowDropDownIcon
                      fontSize="large"
                      data-testid={"decrement-btn"}
                      sx={{ cursor: props.disabled ? "auto" : "pointer" }}
                      onClick={handleDecrement}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

CounterInput.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number,
  setCount: PropTypes.func.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number,
  disabled: PropTypes.bool,
};

export default CounterInput;
